import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'
import {
  WaitScreenWrapper,
  useBodyScrollLock,
} from 'src/components/wait-screen'

const WAIT_SCREEN_SLIDES = [
  {
    title: 'Adding Interactive Blocks to Your Course',
    description:
      'We are adding dynamic sections and interactive elements like flip cards, accordions, tabs, and more to your course. This will just take a moment.',
  },
  {
    title: 'Interact with Your Learners with Community Board',
    description:
      'Your course include community board for discussion topics, peer-to-peer review or just reflection. This will just take a moment.',
  },
  {
    title: 'Adding Games to Your Course Makes It More Engaging',
    description:
      'We are generating games match with your course content so your course will be more engaging. Almost Ready!',
  },
  {
    title: "Quiz Questions for Understanding Learners' Understanding",
    description:
      "We're adding quiz questions at the end of your course, so learners can test themselves. Almost Ready!",
  },
]

const AiLoading = props => {
  const { progressedCardCount, outlineOptionsLength } = props

  // Use shared body scroll lock hook
  useBodyScrollLock()
  const normalizedLength = Math.max(1, outlineOptionsLength)
  const progressValue = Math.max(
    0,
    Math.min(100, (progressedCardCount / normalizedLength) * 100),
  )
  const progressLabel = `${Math.round(progressValue)}%`

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          maxWidth: '300px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/assets/new_mascot_noline_1.gif"
          height={200}
          style={{ margin: '0 auto' }}
        ></img>
        <Box m={0.5}></Box>
        <div className="wait-screen-progress-container">
          <div className="wait-screen-progress-row">
            <div className="wait-screen-progress-track">
              <div
                className="wait-screen-progress-fill"
                style={{ width: `${progressValue}%` }}
              />
            </div>
            <span className="wait-screen-progress-percent">{progressLabel}</span>
          </div>
        </div>
        <Box m={1}></Box>
        <WaitScreenWrapper
          slides={WAIT_SCREEN_SLIDES}
          style={{
            width: '100%',
            maxWidth: '960px',
          }}
        />
        <Box m={0.5}></Box>
        <Typography variant="h4" color="primary">
          AI Assistant is in action!
        </Typography>
        <Typography variant="subtitle" style={{ paddingBottom: '10px' }}>
          Please wait, AI can take up to 1 minute.
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(AiLoading)
